// Generated by ReScript, PLEASE EDIT WITH CARE


var defaultTimeZone_isoAlpha3 = "";

var defaultTimeZone_timeZones = [];

var defaultTimeZone = {
  isoAlpha3: defaultTimeZone_isoAlpha3,
  timeZones: defaultTimeZone_timeZones,
  countryName: "-",
  isoAlpha2: ""
};

var country = [
  {
    timeZones: ["Asia/Kabul"],
    countryName: "Afghanistan",
    isoAlpha2: "AF"
  },
  {
    timeZones: ["Europe/Mariehamn"],
    countryName: "Aland Islands",
    isoAlpha2: "AX"
  },
  {
    timeZones: ["Europe/Tirane"],
    countryName: "Albania",
    isoAlpha2: "AL"
  },
  {
    timeZones: ["Africa/Algiers"],
    countryName: "Algeria",
    isoAlpha2: "DZ"
  },
  {
    timeZones: ["Pacific/Pago_Pago"],
    countryName: "American Samoa",
    isoAlpha2: "AS"
  },
  {
    timeZones: ["Europe/Andorra"],
    countryName: "Andorra",
    isoAlpha2: "AD"
  },
  {
    timeZones: ["Africa/Luanda"],
    countryName: "Angola",
    isoAlpha2: "AO"
  },
  {
    timeZones: ["America/Anguilla"],
    countryName: "Anguilla",
    isoAlpha2: "AI"
  },
  {
    timeZones: [
      "Antarctica/Casey",
      "Antarctica/Davis",
      "Antarctica/DumontDUrville",
      "Antarctica/Mawson",
      "Antarctica/McMurdo",
      "Antarctica/Palmer",
      "Antarctica/Rothera",
      "Antarctica/Syowa",
      "Antarctica/Troll",
      "Antarctica/Vostok"
    ],
    countryName: "Antarctica",
    isoAlpha2: "AQ"
  },
  {
    timeZones: ["America/Antigua"],
    countryName: "Antigua and Barbuda",
    isoAlpha2: "AG"
  },
  {
    timeZones: [
      "America/Argentina/Buenos_Aires",
      "America/Argentina/Catamarca",
      "America/Argentina/Cordoba",
      "America/Argentina/Jujuy",
      "America/Argentina/La_Rioja",
      "America/Argentina/Mendoza",
      "America/Argentina/Rio_Gallegos",
      "America/Argentina/Salta",
      "America/Argentina/San_Juan",
      "America/Argentina/San_Luis",
      "America/Argentina/Tucuman",
      "America/Argentina/Ushuaia"
    ],
    countryName: "Argentina",
    isoAlpha2: "AR"
  },
  {
    timeZones: ["Asia/Yerevan"],
    countryName: "Armenia",
    isoAlpha2: "AM"
  },
  {
    timeZones: ["America/Aruba"],
    countryName: "Aruba",
    isoAlpha2: "AW"
  },
  {
    timeZones: [
      "Antarctica/Macquarie",
      "Australia/Adelaide",
      "Australia/Brisbane",
      "Australia/Broken_Hill",
      "Australia/Currie",
      "Australia/Darwin",
      "Australia/Eucla",
      "Australia/Hobart",
      "Australia/Lindeman",
      "Australia/Lord_Howe",
      "Australia/Melbourne",
      "Australia/Perth",
      "Australia/Sydney"
    ],
    countryName: "Australia",
    isoAlpha2: "AU"
  },
  {
    timeZones: ["Europe/Vienna"],
    countryName: "Austria",
    isoAlpha2: "AT"
  },
  {
    timeZones: ["Asia/Baku"],
    countryName: "Azerbaijan",
    isoAlpha2: "AZ"
  },
  {
    timeZones: ["Asia/Bahrain"],
    countryName: "Bahrain",
    isoAlpha2: "BH"
  },
  {
    timeZones: ["Asia/Dhaka"],
    countryName: "Bangladesh",
    isoAlpha2: "BD"
  },
  {
    timeZones: ["America/Barbados"],
    countryName: "Barbados",
    isoAlpha2: "BB"
  },
  {
    timeZones: ["Europe/Minsk"],
    countryName: "Belarus",
    isoAlpha2: "BY"
  },
  {
    timeZones: ["Europe/Brussels"],
    countryName: "Belgium",
    isoAlpha2: "BE"
  },
  {
    timeZones: ["America/Belize"],
    countryName: "Belize",
    isoAlpha2: "BZ"
  },
  {
    timeZones: ["Africa/Porto-Novo"],
    countryName: "Benin",
    isoAlpha2: "BJ"
  },
  {
    timeZones: ["Atlantic/Bermuda"],
    countryName: "Bermuda",
    isoAlpha2: "BM"
  },
  {
    timeZones: ["Asia/Thimphu"],
    countryName: "Bhutan",
    isoAlpha2: "BT"
  },
  {
    timeZones: ["America/La_Paz"],
    countryName: "Bolivia",
    isoAlpha2: "BO"
  },
  {
    timeZones: ["America/Anguilla"],
    countryName: "Bonaire, Sint Eustatius and Saba",
    isoAlpha2: "BQ"
  },
  {
    timeZones: ["Europe/Sarajevo"],
    countryName: "Bosnia and Herzegovina",
    isoAlpha2: "BA"
  },
  {
    timeZones: ["Africa/Gaborone"],
    countryName: "Botswana",
    isoAlpha2: "BW"
  },
  {
    timeZones: ["Europe/Oslo"],
    countryName: "Bouvet Island",
    isoAlpha2: "BV"
  },
  {
    timeZones: [
      "America/Araguaina",
      "America/Bahia",
      "America/Belem",
      "America/Boa_Vista",
      "America/Campo_Grande",
      "America/Cuiaba",
      "America/Eirunepe",
      "America/Fortaleza",
      "America/Maceio",
      "America/Manaus",
      "America/Noronha",
      "America/Porto_Velho",
      "America/Recife",
      "America/Rio_Branco",
      "America/Santarem",
      "America/Sao_Paulo"
    ],
    countryName: "Brazil",
    isoAlpha2: "BR"
  },
  {
    timeZones: ["Indian/Chagos"],
    countryName: "British Indian Ocean Territory",
    isoAlpha2: "IO"
  },
  {
    timeZones: ["Asia/Brunei"],
    countryName: "Brunei",
    isoAlpha2: "BN"
  },
  {
    timeZones: ["Europe/Sofia"],
    countryName: "Bulgaria",
    isoAlpha2: "BG"
  },
  {
    timeZones: ["Africa/Ouagadougou"],
    countryName: "Burkina Faso",
    isoAlpha2: "BF"
  },
  {
    timeZones: ["Africa/Bujumbura"],
    countryName: "Burundi",
    isoAlpha2: "BI"
  },
  {
    timeZones: ["Asia/Phnom_Penh"],
    countryName: "Cambodia",
    isoAlpha2: "KH"
  },
  {
    timeZones: ["Africa/Douala"],
    countryName: "Cameroon",
    isoAlpha2: "CM"
  },
  {
    timeZones: [
      "America/Atikokan",
      "America/Blanc-Sablon",
      "America/Cambridge_Bay",
      "America/Creston",
      "America/Dawson",
      "America/Dawson_Creek",
      "America/Edmonton",
      "America/Fort_Nelson",
      "America/Glace_Bay",
      "America/Goose_Bay",
      "America/Halifax",
      "America/Inuvik",
      "America/Iqaluit",
      "America/Moncton",
      "America/Nipigon",
      "America/Pangnirtung",
      "America/Rainy_River",
      "America/Rankin_Inlet",
      "America/Regina",
      "America/Resolute",
      "America/St_Johns",
      "America/Swift_Current",
      "America/Thunder_Bay",
      "America/Toronto",
      "America/Vancouver",
      "America/Whitehorse",
      "America/Winnipeg",
      "America/Yellowknife"
    ],
    countryName: "Canada",
    isoAlpha2: "CA"
  },
  {
    timeZones: ["Atlantic/Cape_Verde"],
    countryName: "Cape Verde",
    isoAlpha2: "CV"
  },
  {
    timeZones: ["America/Cayman"],
    countryName: "Cayman Islands",
    isoAlpha2: "KY"
  },
  {
    timeZones: ["Africa/Bangui"],
    countryName: "Central African Republic",
    isoAlpha2: "CF"
  },
  {
    timeZones: ["Africa/Ndjamena"],
    countryName: "Chad",
    isoAlpha2: "TD"
  },
  {
    timeZones: [
      "America/Punta_Arenas",
      "America/Santiago",
      "Pacific/Easter"
    ],
    countryName: "Chile",
    isoAlpha2: "CL"
  },
  {
    timeZones: [
      "Asia/Shanghai",
      "Asia/Urumqi"
    ],
    countryName: "China",
    isoAlpha2: "CN"
  },
  {
    timeZones: ["Indian/Christmas"],
    countryName: "Christmas Island",
    isoAlpha2: "CX"
  },
  {
    timeZones: ["Indian/Cocos"],
    countryName: "Cocos (Keeling) Islands",
    isoAlpha2: "CC"
  },
  {
    timeZones: ["America/Bogota"],
    countryName: "Colombia",
    isoAlpha2: "CO"
  },
  {
    timeZones: ["Indian/Comoro"],
    countryName: "Comoros",
    isoAlpha2: "KM"
  },
  {
    timeZones: ["Africa/Brazzaville"],
    countryName: "Congo",
    isoAlpha2: "CG"
  },
  {
    timeZones: ["Pacific/Rarotonga"],
    countryName: "Cook Islands",
    isoAlpha2: "CK"
  },
  {
    timeZones: ["America/Costa_Rica"],
    countryName: "Costa Rica",
    isoAlpha2: "CR"
  },
  {
    timeZones: ["Africa/Abidjan"],
    countryName: "Cote D'Ivoire (Ivory Coast)",
    isoAlpha2: "CI"
  },
  {
    timeZones: ["Europe/Zagreb"],
    countryName: "Croatia",
    isoAlpha2: "HR"
  },
  {
    timeZones: ["America/Havana"],
    countryName: "Cuba",
    isoAlpha2: "CU"
  },
  {
    timeZones: ["America/Curacao"],
    countryName: "Curaçao",
    isoAlpha2: "CW"
  },
  {
    timeZones: [
      "Asia/Famagusta",
      "Asia/Nicosia"
    ],
    countryName: "Cyprus",
    isoAlpha2: "CY"
  },
  {
    timeZones: ["Europe/Prague"],
    countryName: "Czech Republic",
    isoAlpha2: "CZ"
  },
  {
    timeZones: [
      "Africa/Kinshasa",
      "Africa/Lubumbashi"
    ],
    countryName: "Democratic Republic of the Congo",
    isoAlpha2: "CD"
  },
  {
    timeZones: ["Europe/Copenhagen"],
    countryName: "Denmark",
    isoAlpha2: "DK"
  },
  {
    timeZones: ["Africa/Djibouti"],
    countryName: "Djibouti",
    isoAlpha2: "DJ"
  },
  {
    timeZones: ["America/Dominica"],
    countryName: "Dominica",
    isoAlpha2: "DM"
  },
  {
    timeZones: ["America/Santo_Domingo"],
    countryName: "Dominican Republic",
    isoAlpha2: "DO"
  },
  {
    timeZones: [
      "America/Guayaquil",
      "Pacific/Galapagos"
    ],
    countryName: "Ecuador",
    isoAlpha2: "EC"
  },
  {
    timeZones: ["Africa/Cairo"],
    countryName: "Egypt",
    isoAlpha2: "EG"
  },
  {
    timeZones: ["America/El_Salvador"],
    countryName: "El Salvador",
    isoAlpha2: "SV"
  },
  {
    timeZones: ["Africa/Malabo"],
    countryName: "Equatorial Guinea",
    isoAlpha2: "GQ"
  },
  {
    timeZones: ["Africa/Asmara"],
    countryName: "Eritrea",
    isoAlpha2: "ER"
  },
  {
    timeZones: ["Europe/Tallinn"],
    countryName: "Estonia",
    isoAlpha2: "EE"
  },
  {
    timeZones: ["Africa/Mbabane"],
    countryName: "Eswatini",
    isoAlpha2: "SZ"
  },
  {
    timeZones: ["Africa/Addis_Ababa"],
    countryName: "Ethiopia",
    isoAlpha2: "ET"
  },
  {
    timeZones: ["Atlantic/Stanley"],
    countryName: "Falkland Islands",
    isoAlpha2: "FK"
  },
  {
    timeZones: ["Atlantic/Faroe"],
    countryName: "Faroe Islands",
    isoAlpha2: "FO"
  },
  {
    timeZones: ["Pacific/Fiji"],
    countryName: "Fiji Islands",
    isoAlpha2: "FJ"
  },
  {
    timeZones: ["Europe/Helsinki"],
    countryName: "Finland",
    isoAlpha2: "FI"
  },
  {
    timeZones: ["Europe/Paris"],
    countryName: "France",
    isoAlpha2: "FR"
  },
  {
    timeZones: ["America/Cayenne"],
    countryName: "French Guiana",
    isoAlpha2: "GF"
  },
  {
    timeZones: [
      "Pacific/Gambier",
      "Pacific/Marquesas",
      "Pacific/Tahiti"
    ],
    countryName: "French Polynesia",
    isoAlpha2: "PF"
  },
  {
    timeZones: ["Indian/Kerguelen"],
    countryName: "French Southern Territories",
    isoAlpha2: "TF"
  },
  {
    timeZones: ["Africa/Libreville"],
    countryName: "Gabon",
    isoAlpha2: "GA"
  },
  {
    timeZones: ["Asia/Tbilisi"],
    countryName: "Georgia",
    isoAlpha2: "GE"
  },
  {
    timeZones: [
      "Europe/Berlin",
      "Europe/Busingen"
    ],
    countryName: "Germany",
    isoAlpha2: "DE"
  },
  {
    timeZones: ["Africa/Accra"],
    countryName: "Ghana",
    isoAlpha2: "GH"
  },
  {
    timeZones: ["Europe/Gibraltar"],
    countryName: "Gibraltar",
    isoAlpha2: "GI"
  },
  {
    timeZones: ["Europe/Athens"],
    countryName: "Greece",
    isoAlpha2: "GR"
  },
  {
    timeZones: [
      "America/Danmarkshavn",
      "America/Nuuk",
      "America/Scoresbysund",
      "America/Thule"
    ],
    countryName: "Greenland",
    isoAlpha2: "GL"
  },
  {
    timeZones: ["America/Grenada"],
    countryName: "Grenada",
    isoAlpha2: "GD"
  },
  {
    timeZones: ["America/Guadeloupe"],
    countryName: "Guadeloupe",
    isoAlpha2: "GP"
  },
  {
    timeZones: ["Pacific/Guam"],
    countryName: "Guam",
    isoAlpha2: "GU"
  },
  {
    timeZones: ["America/Guatemala"],
    countryName: "Guatemala",
    isoAlpha2: "GT"
  },
  {
    timeZones: ["Europe/Guernsey"],
    countryName: "Guernsey and Alderney",
    isoAlpha2: "GG"
  },
  {
    timeZones: ["Africa/Conakry"],
    countryName: "Guinea",
    isoAlpha2: "GN"
  },
  {
    timeZones: ["Africa/Bissau"],
    countryName: "Guinea-Bissau",
    isoAlpha2: "GW"
  },
  {
    timeZones: ["America/Guyana"],
    countryName: "Guyana",
    isoAlpha2: "GY"
  },
  {
    timeZones: ["America/Port-au-Prince"],
    countryName: "Haiti",
    isoAlpha2: "HT"
  },
  {
    timeZones: ["Indian/Kerguelen"],
    countryName: "Heard Island and McDonald Islands",
    isoAlpha2: "HM"
  },
  {
    timeZones: ["America/Tegucigalpa"],
    countryName: "Honduras",
    isoAlpha2: "HN"
  },
  {
    timeZones: ["Asia/Hong_Kong"],
    countryName: "Hong Kong S.A.R.",
    isoAlpha2: "HK"
  },
  {
    timeZones: ["Europe/Budapest"],
    countryName: "Hungary",
    isoAlpha2: "HU"
  },
  {
    timeZones: ["Atlantic/Reykjavik"],
    countryName: "Iceland",
    isoAlpha2: "IS"
  },
  {
    timeZones: [
      "Asia/Kolkata",
      "Asia/Calcutta"
    ],
    countryName: "India",
    isoAlpha2: "IN"
  },
  {
    timeZones: [
      "Asia/Jakarta",
      "Asia/Jayapura",
      "Asia/Makassar",
      "Asia/Pontianak"
    ],
    countryName: "Indonesia",
    isoAlpha2: "ID"
  },
  {
    timeZones: ["Asia/Tehran"],
    countryName: "Iran",
    isoAlpha2: "IR"
  },
  {
    timeZones: ["Asia/Baghdad"],
    countryName: "Iraq",
    isoAlpha2: "IQ"
  },
  {
    timeZones: ["Europe/Dublin"],
    countryName: "Ireland",
    isoAlpha2: "IE"
  },
  {
    timeZones: ["Asia/Jerusalem"],
    countryName: "Israel",
    isoAlpha2: "IL"
  },
  {
    timeZones: ["Europe/Rome"],
    countryName: "Italy",
    isoAlpha2: "IT"
  },
  {
    timeZones: ["America/Jamaica"],
    countryName: "Jamaica",
    isoAlpha2: "JM"
  },
  {
    timeZones: ["Asia/Tokyo"],
    countryName: "Japan",
    isoAlpha2: "JP"
  },
  {
    timeZones: ["Europe/Jersey"],
    countryName: "Jersey",
    isoAlpha2: "JE"
  },
  {
    timeZones: ["Asia/Amman"],
    countryName: "Jordan",
    isoAlpha2: "JO"
  },
  {
    timeZones: [
      "Asia/Almaty",
      "Asia/Aqtau",
      "Asia/Aqtobe",
      "Asia/Atyrau",
      "Asia/Oral",
      "Asia/Qostanay",
      "Asia/Qyzylorda"
    ],
    countryName: "Kazakhstan",
    isoAlpha2: "KZ"
  },
  {
    timeZones: ["Africa/Nairobi"],
    countryName: "Kenya",
    isoAlpha2: "KE"
  },
  {
    timeZones: [
      "Pacific/Enderbury",
      "Pacific/Kiritimati",
      "Pacific/Tarawa"
    ],
    countryName: "Kiribati",
    isoAlpha2: "KI"
  },
  {
    timeZones: ["Europe/Belgrade"],
    countryName: "Kosovo",
    isoAlpha2: "XK"
  },
  {
    timeZones: ["Asia/Kuwait"],
    countryName: "Kuwait",
    isoAlpha2: "KW"
  },
  {
    timeZones: ["Asia/Bishkek"],
    countryName: "Kyrgyzstan",
    isoAlpha2: "KG"
  },
  {
    timeZones: ["Asia/Vientiane"],
    countryName: "Laos",
    isoAlpha2: "LA"
  },
  {
    timeZones: ["Europe/Riga"],
    countryName: "Latvia",
    isoAlpha2: "LV"
  },
  {
    timeZones: ["Asia/Beirut"],
    countryName: "Lebanon",
    isoAlpha2: "LB"
  },
  {
    timeZones: ["Africa/Maseru"],
    countryName: "Lesotho",
    isoAlpha2: "LS"
  },
  {
    timeZones: ["Africa/Monrovia"],
    countryName: "Liberia",
    isoAlpha2: "LR"
  },
  {
    timeZones: ["Africa/Tripoli"],
    countryName: "Libya",
    isoAlpha2: "LY"
  },
  {
    timeZones: ["Europe/Vaduz"],
    countryName: "Liechtenstein",
    isoAlpha2: "LI"
  },
  {
    timeZones: ["Europe/Vilnius"],
    countryName: "Lithuania",
    isoAlpha2: "LT"
  },
  {
    timeZones: ["Europe/Luxembourg"],
    countryName: "Luxembourg",
    isoAlpha2: "LU"
  },
  {
    timeZones: ["Asia/Macau"],
    countryName: "Macau S.A.R.",
    isoAlpha2: "MO"
  },
  {
    timeZones: ["Indian/Antananarivo"],
    countryName: "Madagascar",
    isoAlpha2: "MG"
  },
  {
    timeZones: ["Africa/Blantyre"],
    countryName: "Malawi",
    isoAlpha2: "MW"
  },
  {
    timeZones: [
      "Asia/Kuala_Lumpur",
      "Asia/Kuching"
    ],
    countryName: "Malaysia",
    isoAlpha2: "MY"
  },
  {
    timeZones: ["Indian/Maldives"],
    countryName: "Maldives",
    isoAlpha2: "MV"
  },
  {
    timeZones: ["Africa/Bamako"],
    countryName: "Mali",
    isoAlpha2: "ML"
  },
  {
    timeZones: ["Europe/Malta"],
    countryName: "Malta",
    isoAlpha2: "MT"
  },
  {
    timeZones: ["Europe/Isle_of_Man"],
    countryName: "Man (Isle of)",
    isoAlpha2: "IM"
  },
  {
    timeZones: [
      "Pacific/Kwajalein",
      "Pacific/Majuro"
    ],
    countryName: "Marshall Islands",
    isoAlpha2: "MH"
  },
  {
    timeZones: ["America/Martinique"],
    countryName: "Martinique",
    isoAlpha2: "MQ"
  },
  {
    timeZones: ["Africa/Nouakchott"],
    countryName: "Mauritania",
    isoAlpha2: "MR"
  },
  {
    timeZones: ["Indian/Mauritius"],
    countryName: "Mauritius",
    isoAlpha2: "MU"
  },
  {
    timeZones: ["Indian/Mayotte"],
    countryName: "Mayotte",
    isoAlpha2: "YT"
  },
  {
    timeZones: [
      "America/Bahia_Banderas",
      "America/Cancun",
      "America/Chihuahua",
      "America/Hermosillo",
      "America/Matamoros",
      "America/Mazatlan",
      "America/Merida",
      "America/Mexico_City",
      "America/Monterrey",
      "America/Ojinaga",
      "America/Tijuana"
    ],
    countryName: "Mexico",
    isoAlpha2: "MX"
  },
  {
    timeZones: [
      "Pacific/Chuuk",
      "Pacific/Kosrae",
      "Pacific/Pohnpei"
    ],
    countryName: "Micronesia",
    isoAlpha2: "FM"
  },
  {
    timeZones: ["Europe/Chisinau"],
    countryName: "Moldova",
    isoAlpha2: "MD"
  },
  {
    timeZones: ["Europe/Monaco"],
    countryName: "Monaco",
    isoAlpha2: "MC"
  },
  {
    timeZones: [
      "Asia/Choibalsan",
      "Asia/Hovd",
      "Asia/Ulaanbaatar"
    ],
    countryName: "Mongolia",
    isoAlpha2: "MN"
  },
  {
    timeZones: ["Europe/Podgorica"],
    countryName: "Montenegro",
    isoAlpha2: "ME"
  },
  {
    timeZones: ["America/Montserrat"],
    countryName: "Montserrat",
    isoAlpha2: "MS"
  },
  {
    timeZones: ["Africa/Casablanca"],
    countryName: "Morocco",
    isoAlpha2: "MA"
  },
  {
    timeZones: ["Africa/Maputo"],
    countryName: "Mozambique",
    isoAlpha2: "MZ"
  },
  {
    timeZones: ["Asia/Yangon"],
    countryName: "Myanmar",
    isoAlpha2: "MM"
  },
  {
    timeZones: ["Africa/Windhoek"],
    countryName: "Namibia",
    isoAlpha2: "NA"
  },
  {
    timeZones: ["Pacific/Nauru"],
    countryName: "Nauru",
    isoAlpha2: "NR"
  },
  {
    timeZones: ["Asia/Kathmandu"],
    countryName: "Nepal",
    isoAlpha2: "NP"
  },
  {
    timeZones: ["Europe/Amsterdam"],
    countryName: "Netherlands",
    isoAlpha2: "NL"
  },
  {
    timeZones: ["Pacific/Noumea"],
    countryName: "New Caledonia",
    isoAlpha2: "NC"
  },
  {
    timeZones: [
      "Pacific/Auckland",
      "Pacific/Chatham"
    ],
    countryName: "New Zealand",
    isoAlpha2: "NZ"
  },
  {
    timeZones: ["America/Managua"],
    countryName: "Nicaragua",
    isoAlpha2: "NI"
  },
  {
    timeZones: ["Africa/Niamey"],
    countryName: "Niger",
    isoAlpha2: "NE"
  },
  {
    timeZones: ["Africa/Lagos"],
    countryName: "Nigeria",
    isoAlpha2: "NG"
  },
  {
    timeZones: ["Pacific/Niue"],
    countryName: "Niue",
    isoAlpha2: "NU"
  },
  {
    timeZones: ["Pacific/Norfolk"],
    countryName: "Norfolk Island",
    isoAlpha2: "NF"
  },
  {
    timeZones: ["Asia/Pyongyang"],
    countryName: "North Korea",
    isoAlpha2: "KP"
  },
  {
    timeZones: ["Europe/Skopje"],
    countryName: "North Macedonia",
    isoAlpha2: "MK"
  },
  {
    timeZones: ["Pacific/Saipan"],
    countryName: "Northern Mariana Islands",
    isoAlpha2: "MP"
  },
  {
    timeZones: ["Europe/Oslo"],
    countryName: "Norway",
    isoAlpha2: "NO"
  },
  {
    timeZones: ["Asia/Muscat"],
    countryName: "Oman",
    isoAlpha2: "OM"
  },
  {
    timeZones: ["Asia/Karachi"],
    countryName: "Pakistan",
    isoAlpha2: "PK"
  },
  {
    timeZones: ["Pacific/Palau"],
    countryName: "Palau",
    isoAlpha2: "PW"
  },
  {
    timeZones: [
      "Asia/Gaza",
      "Asia/Hebron"
    ],
    countryName: "Palestinian Territory Occupied",
    isoAlpha2: "PS"
  },
  {
    timeZones: ["America/Panama"],
    countryName: "Panama",
    isoAlpha2: "PA"
  },
  {
    timeZones: [
      "Pacific/Bougainville",
      "Pacific/Port_Moresby"
    ],
    countryName: "Papua New Guinea",
    isoAlpha2: "PG"
  },
  {
    timeZones: ["America/Asuncion"],
    countryName: "Paraguay",
    isoAlpha2: "PY"
  },
  {
    timeZones: ["America/Lima"],
    countryName: "Peru",
    isoAlpha2: "PE"
  },
  {
    timeZones: ["Asia/Manila"],
    countryName: "Philippines",
    isoAlpha2: "PH"
  },
  {
    timeZones: ["Pacific/Pitcairn"],
    countryName: "Pitcairn Island",
    isoAlpha2: "PN"
  },
  {
    timeZones: ["Europe/Warsaw"],
    countryName: "Poland",
    isoAlpha2: "PL"
  },
  {
    timeZones: [
      "Atlantic/Azores",
      "Atlantic/Madeira",
      "Europe/Lisbon"
    ],
    countryName: "Portugal",
    isoAlpha2: "PT"
  },
  {
    timeZones: ["America/Puerto_Rico"],
    countryName: "Puerto Rico",
    isoAlpha2: "PR"
  },
  {
    timeZones: ["Asia/Qatar"],
    countryName: "Qatar",
    isoAlpha2: "QA"
  },
  {
    timeZones: ["Indian/Reunion"],
    countryName: "Reunion",
    isoAlpha2: "RE"
  },
  {
    timeZones: ["Europe/Bucharest"],
    countryName: "Romania",
    isoAlpha2: "RO"
  },
  {
    timeZones: [
      "Asia/Anadyr",
      "Asia/Barnaul",
      "Asia/Chita",
      "Asia/Irkutsk",
      "Asia/Kamchatka",
      "Asia/Khandyga",
      "Asia/Krasnoyarsk",
      "Asia/Magadan",
      "Asia/Novokuznetsk",
      "Asia/Novosibirsk",
      "Asia/Omsk",
      "Asia/Sakhalin",
      "Asia/Srednekolymsk",
      "Asia/Tomsk",
      "Asia/Ust-Nera",
      "Asia/Vladivostok",
      "Asia/Yakutsk",
      "Asia/Yekaterinburg",
      "Europe/Astrakhan",
      "Europe/Kaliningrad",
      "Europe/Kirov",
      "Europe/Moscow",
      "Europe/Samara",
      "Europe/Saratov",
      "Europe/Ulyanovsk",
      "Europe/Volgograd"
    ],
    countryName: "Russia",
    isoAlpha2: "RU"
  },
  {
    timeZones: ["Africa/Kigali"],
    countryName: "Rwanda",
    isoAlpha2: "RW"
  },
  {
    timeZones: ["Atlantic/St_Helena"],
    countryName: "Saint Helena",
    isoAlpha2: "SH"
  },
  {
    timeZones: ["America/St_Kitts"],
    countryName: "Saint Kitts and Nevis",
    isoAlpha2: "KN"
  },
  {
    timeZones: ["America/St_Lucia"],
    countryName: "Saint Lucia",
    isoAlpha2: "LC"
  },
  {
    timeZones: ["America/Miquelon"],
    countryName: "Saint Pierre and Miquelon",
    isoAlpha2: "PM"
  },
  {
    timeZones: ["America/St_Vincent"],
    countryName: "Saint Vincent and the Grenadines",
    isoAlpha2: "VC"
  },
  {
    timeZones: ["America/St_Barthelemy"],
    countryName: "Saint-Barthelemy",
    isoAlpha2: "BL"
  },
  {
    timeZones: ["America/Marigot"],
    countryName: "Saint-Martin (French part)",
    isoAlpha2: "MF"
  },
  {
    timeZones: ["Pacific/Apia"],
    countryName: "Samoa",
    isoAlpha2: "WS"
  },
  {
    timeZones: ["Europe/San_Marino"],
    countryName: "San Marino",
    isoAlpha2: "SM"
  },
  {
    timeZones: ["Africa/Sao_Tome"],
    countryName: "Sao Tome and Principe",
    isoAlpha2: "ST"
  },
  {
    timeZones: ["Asia/Riyadh"],
    countryName: "Saudi Arabia",
    isoAlpha2: "SA"
  },
  {
    timeZones: ["Africa/Dakar"],
    countryName: "Senegal",
    isoAlpha2: "SN"
  },
  {
    timeZones: ["Europe/Belgrade"],
    countryName: "Serbia",
    isoAlpha2: "RS"
  },
  {
    timeZones: ["Indian/Mahe"],
    countryName: "Seychelles",
    isoAlpha2: "SC"
  },
  {
    timeZones: ["Africa/Freetown"],
    countryName: "Sierra Leone",
    isoAlpha2: "SL"
  },
  {
    timeZones: ["Asia/Singapore"],
    countryName: "Singapore",
    isoAlpha2: "SG"
  },
  {
    timeZones: ["America/Anguilla"],
    countryName: "Sint Maarten (Dutch part)",
    isoAlpha2: "SX"
  },
  {
    timeZones: ["Europe/Bratislava"],
    countryName: "Slovakia",
    isoAlpha2: "SK"
  },
  {
    timeZones: ["Europe/Ljubljana"],
    countryName: "Slovenia",
    isoAlpha2: "SI"
  },
  {
    timeZones: ["Pacific/Guadalcanal"],
    countryName: "Solomon Islands",
    isoAlpha2: "SB"
  },
  {
    timeZones: ["Africa/Mogadishu"],
    countryName: "Somalia",
    isoAlpha2: "SO"
  },
  {
    timeZones: ["Africa/Johannesburg"],
    countryName: "South Africa",
    isoAlpha2: "ZA"
  },
  {
    timeZones: ["Atlantic/South_Georgia"],
    countryName: "South Georgia",
    isoAlpha2: "GS"
  },
  {
    timeZones: ["Asia/Seoul"],
    countryName: "South Korea",
    isoAlpha2: "KR"
  },
  {
    timeZones: ["Africa/Juba"],
    countryName: "South Sudan",
    isoAlpha2: "SS"
  },
  {
    timeZones: [
      "Africa/Ceuta",
      "Atlantic/Canary",
      "Europe/Madrid"
    ],
    countryName: "Spain",
    isoAlpha2: "ES"
  },
  {
    timeZones: ["Asia/Colombo"],
    countryName: "Sri Lanka",
    isoAlpha2: "LK"
  },
  {
    timeZones: ["Africa/Khartoum"],
    countryName: "Sudan",
    isoAlpha2: "SD"
  },
  {
    timeZones: ["America/Paramaribo"],
    countryName: "Suriname",
    isoAlpha2: "SR"
  },
  {
    timeZones: ["Arctic/Longyearbyen"],
    countryName: "Svalbard and Jan Mayen Islands",
    isoAlpha2: "SJ"
  },
  {
    timeZones: ["Europe/Stockholm"],
    countryName: "Sweden",
    isoAlpha2: "SE"
  },
  {
    timeZones: ["Europe/Zurich"],
    countryName: "Switzerland",
    isoAlpha2: "CH"
  },
  {
    timeZones: ["Asia/Damascus"],
    countryName: "Syria",
    isoAlpha2: "SY"
  },
  {
    timeZones: ["Asia/Taipei"],
    countryName: "Taiwan",
    isoAlpha2: "TW"
  },
  {
    timeZones: ["Asia/Dushanbe"],
    countryName: "Tajikistan",
    isoAlpha2: "TJ"
  },
  {
    timeZones: ["Africa/Dar_es_Salaam"],
    countryName: "Tanzania",
    isoAlpha2: "TZ"
  },
  {
    timeZones: ["Asia/Bangkok"],
    countryName: "Thailand",
    isoAlpha2: "TH"
  },
  {
    timeZones: ["America/Nassau"],
    countryName: "The Bahamas",
    isoAlpha2: "BS"
  },
  {
    timeZones: ["Africa/Banjul"],
    countryName: "The Gambia ",
    isoAlpha2: "GM"
  },
  {
    timeZones: ["Asia/Dili"],
    countryName: "Timor-Leste",
    isoAlpha2: "TL"
  },
  {
    timeZones: ["Africa/Lome"],
    countryName: "Togo",
    isoAlpha2: "TG"
  },
  {
    timeZones: ["Pacific/Fakaofo"],
    countryName: "Tokelau",
    isoAlpha2: "TK"
  },
  {
    timeZones: ["Pacific/Tongatapu"],
    countryName: "Tonga",
    isoAlpha2: "TO"
  },
  {
    timeZones: ["America/Port_of_Spain"],
    countryName: "Trinidad and Tobago",
    isoAlpha2: "TT"
  },
  {
    timeZones: ["Africa/Tunis"],
    countryName: "Tunisia",
    isoAlpha2: "TN"
  },
  {
    timeZones: ["Europe/Istanbul"],
    countryName: "Turkey",
    isoAlpha2: "TR"
  },
  {
    timeZones: ["Asia/Ashgabat"],
    countryName: "Turkmenistan",
    isoAlpha2: "TM"
  },
  {
    timeZones: ["America/Grand_Turk"],
    countryName: "Turks and Caicos Islands",
    isoAlpha2: "TC"
  },
  {
    timeZones: ["Pacific/Funafuti"],
    countryName: "Tuvalu",
    isoAlpha2: "TV"
  },
  {
    timeZones: ["Africa/Kampala"],
    countryName: "Uganda",
    isoAlpha2: "UG"
  },
  {
    timeZones: [
      "Europe/Kiev",
      "Europe/Simferopol",
      "Europe/Uzhgorod",
      "Europe/Zaporozhye"
    ],
    countryName: "Ukraine",
    isoAlpha2: "UA"
  },
  {
    timeZones: ["Asia/Dubai"],
    countryName: "United Arab Emirates",
    isoAlpha2: "AE"
  },
  {
    timeZones: ["Europe/London"],
    countryName: "United Kingdom",
    isoAlpha2: "GB"
  },
  {
    timeZones: [
      "America/Adak",
      "America/Anchorage",
      "America/Boise",
      "America/Chicago",
      "America/Denver",
      "America/Detroit",
      "America/Indiana/Indianapolis",
      "America/Indiana/Knox",
      "America/Indiana/Marengo",
      "America/Indiana/Petersburg",
      "America/Indiana/Tell_City",
      "America/Indiana/Vevay",
      "America/Indiana/Vincennes",
      "America/Indiana/Winamac",
      "America/Juneau",
      "America/Kentucky/Louisville",
      "America/Kentucky/Monticello",
      "America/Los_Angeles",
      "America/Menominee",
      "America/Metlakatla",
      "America/New_York",
      "America/Nome",
      "America/North_Dakota/Beulah",
      "America/North_Dakota/Center",
      "America/North_Dakota/New_Salem",
      "America/Phoenix",
      "America/Sitka",
      "America/Yakutat",
      "Pacific/Honolulu"
    ],
    countryName: "United States",
    isoAlpha2: "US"
  },
  {
    timeZones: [
      "Pacific/Midway",
      "Pacific/Wake"
    ],
    countryName: "United States Minor Outlying Islands",
    isoAlpha2: "UM"
  },
  {
    timeZones: ["America/Montevideo"],
    countryName: "Uruguay",
    isoAlpha2: "UY"
  },
  {
    timeZones: [
      "Asia/Samarkand",
      "Asia/Tashkent"
    ],
    countryName: "Uzbekistan",
    isoAlpha2: "UZ"
  },
  {
    timeZones: ["Pacific/Efate"],
    countryName: "Vanuatu",
    isoAlpha2: "VU"
  },
  {
    timeZones: ["Europe/Vatican"],
    countryName: "Vatican City State (Holy See)",
    isoAlpha2: "VA"
  },
  {
    timeZones: ["America/Caracas"],
    countryName: "Venezuela",
    isoAlpha2: "VE"
  },
  {
    timeZones: ["Asia/Ho_Chi_Minh"],
    countryName: "Vietnam",
    isoAlpha2: "VN"
  },
  {
    timeZones: ["America/Tortola"],
    countryName: "Virgin Islands (British)",
    isoAlpha2: "VG"
  },
  {
    timeZones: ["America/St_Thomas"],
    countryName: "Virgin Islands (US)",
    isoAlpha2: "VI"
  },
  {
    timeZones: ["Pacific/Wallis"],
    countryName: "Wallis and Futuna Islands",
    isoAlpha2: "WF"
  },
  {
    timeZones: ["Africa/El_Aaiun"],
    countryName: "Western Sahara",
    isoAlpha2: "EH"
  },
  {
    timeZones: ["Asia/Aden"],
    countryName: "Yemen",
    isoAlpha2: "YE"
  },
  {
    timeZones: ["Africa/Lusaka"],
    countryName: "Zambia",
    isoAlpha2: "ZM"
  },
  {
    timeZones: ["Africa/Harare"],
    countryName: "Zimbabwe",
    isoAlpha2: "ZW"
  }
];

var sofortCountries = [
  {
    isoAlpha3: "AUT",
    timeZones: ["Europe/Vienna"],
    countryName: "Austria",
    isoAlpha2: "AT"
  },
  {
    isoAlpha3: "BEL",
    timeZones: ["Europe/Brussels"],
    countryName: "Belgium",
    isoAlpha2: "BE"
  },
  {
    isoAlpha3: "DEU",
    timeZones: [
      "Europe/Berlin",
      "Europe/Busingen"
    ],
    countryName: "Germany",
    isoAlpha2: "DE"
  },
  {
    isoAlpha3: "ITA",
    timeZones: ["Europe/Rome"],
    countryName: "Italy",
    isoAlpha2: "IT"
  },
  {
    isoAlpha3: "NLD",
    timeZones: ["Europe/Amsterdam"],
    countryName: "Netherlands",
    isoAlpha2: "NL"
  },
  {
    isoAlpha3: "ESP",
    timeZones: [
      "Europe/Madrid",
      "Africa/Ceuta",
      "Atlantic/Canary"
    ],
    countryName: "Spain",
    isoAlpha2: "ES"
  }
];

function getCountry(paymentMethodName, countryList) {
  if (paymentMethodName === "sofort") {
    return sofortCountries;
  } else {
    return countryList;
  }
}

export {
  defaultTimeZone ,
  country ,
  sofortCountries ,
  getCountry ,
}
/* No side effect */
